// extracted by mini-css-extract-plugin
module.exports = {"exchangeSearch":"_6I0C_Z","input":"Q5Cwht","icon":"OOfR1h"};